import Toast from "@/common/components/ui/toast";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePurchaseReturn from "./components/tables/TablePurchaseReturn";

function PurchaseReturnRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePurchaseReturn />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchaseReturnRegister;